import { WaitLoadingService } from './../components/common/waitLoading/wait-loading.service';
import { PlycaDataService } from './../../services/plyca.service';
import { ProjectEntityDTO } from './../api/plyca-dtos-v2';
import {
  Component,
  AfterContentInit,
  OnInit,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { getSimpleIdentifierFromString } from '../api/plyca-dtos';
import { PaginationDTO } from '../api/PaginationModel';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../user.service';
import { TranslateService } from '@ngx-translate/core';
import { tap, finalize, switchMap } from 'rxjs/operators';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { MilestoneDTO } from '../api/plyca-dtos-v2';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { CalendarEventComponent } from './calendarEvent.component';
import { DatePipe } from '@angular/common';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { Configuration } from '../conf/app.constants';
import { generateRandomIdentifier, UIService } from '../ui.service';
import {
  DATEPIPE_DATETIME_FORMAT,
  DATEPIPE_DATE_FORMAT,
} from '../../services/language.service';
import { FullCalendar } from 'primeng-lts/fullcalendar';

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.template.html',
  styles: [
    `
      .ui-grid-row div {
        padding: 4px 10px;
      }

      .ui-grid-row div label {
        font-weight: bold;
      }
    `,
  ],

  providers: [DatePipe, DialogService, UIService],
})
export class calendarComponent
  extends BaseComponent
  implements OnInit, AfterContentInit, OnDestroy
{
  public DATET_FORMAT_DATEPIPE = DATEPIPE_DATE_FORMAT;
  public DATEPIPE_DATETIME_FORMAT = DATEPIPE_DATETIME_FORMAT;
  showHeader = true;

  private millestones: Array<MilestoneDTO>;
  events: Array<any> = [];
  public options: any;

  dialogVisible = false;
  myEvent: MilestoneDTO;
  userFullName: string;

  project: ProjectEntityDTO;
  division = 0;
  milestoneType: any;

  private calMode: string;
  types: any;

  isModalWindow = false;
  windowHash: any;

  loaded = false;
  showPanel = true;

  public calendarPlugins = [dayGridPlugin, timeGridPlugin, interactionPlugin];

  @ViewChild('fc')
  public calendarView: FullCalendar;

  constructor(
    private route: ActivatedRoute,
    public helpService: HelpService,
    public uiService: UIService,
    private userService: UserService,
    private headerActionsService: HeaderActionsService,
    private dialogService: DialogService,
    public dialogConfig: DynamicDialogConfig,
    private datePipe: DatePipe,
    public configuration: Configuration,
    private translationService: TranslateService,
    private plycaService: PlycaDataService,
    private waitService: WaitLoadingService,
    private elem: ElementRef
  ) {
    super();
    this.subscribe(
      this.helpService.showContextHelpObservable(HelpType.CALENDAR)
    );

    // Calendario del usuario
    this.calMode = 'MU';

    // Cuando se muestra desde el área del expediente
    this.route.params.subscribe((params) => {
      if (params && params['id']) {
        this.calMode = 'ME';
        this.project = {} as ProjectEntityDTO;
        this.project.identifier = params['id'];
        this.showPanel = false;
      }
    });

    // Se incluye la apertura modal en modo expediente
    // REcopilación de parámetros

    if (dialogConfig && dialogConfig['project']) {
      this.isModalWindow = true;

      this.calMode = 'ME';

      if (dialogConfig['project']) {
        this.isModalWindow = true;
        this.project = dialogConfig['project'];
      }
      this.division = 0;
      if (dialogConfig['division']) {
        this.division = dialogConfig['division'];
      }
      if (dialogConfig['typeMilestone']) {
        this.milestoneType = dialogConfig['typeMilestone'];
      }
    }
  }
  ngOnInit() {
    this.waitService.startWaiting();
    // DATOS DEL EXPEDIENTE NECESARIOS
    if (this.calMode === 'ME') {
      this.subscribe(
        this.plycaService
          .get<ProjectEntityDTO>(
            this.configuration.PROJECTENTITY_SERVICE_URL,
            this.project.identifier,
            {
              expand: 'expansionSet:minimal',
            }
          )
          .pipe(finalize(() => this.calendarConfig())),
        (result: any) => {
          this.project = result;
          this.loaded = true;
        }
      );
    } else {
      this.loaded = true;
      this.calendarConfig();
    }
  }

  calendarConfig() {
    // CONFIGURACION DEL CALENDARIO
    // TODO se internacionaliza a español para que no salga en inglés
    // Falta  comprobar this.translate.currentLang para que cambie con las banderas
    // Pero el fullcalendar no tiene todos los textos de ca ni de gl
    this.options = {
      plugins: this.calendarPlugins,
      defaultView: 'dayGridMonth',
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay',
      },
      locale: esLocale,
      timeFormat: 'H(:mm)',
      dateFormat: 'dd/mm/yy',
      editable: false,
      eventClick: this.handleEventClick.bind(this),
      datesRender: this.loadEvents.bind(this),
    };
  }

  ngAfterContentInit(): void {
    // DATOS DEL USUARIO NECESARIOS
    this.userFullName = this.userService.getUserFullName();

    // Configuración del sub-header
    if (this.isModalWindow) {
      this.windowHash = generateRandomIdentifier();
      // this.headerActionsService.clearWindowActions(this.windowHash);

      this.subscribe(
        this.headerActionsService.addWindowAction(
          'Calendar.add',
          'fas fa-plus',
          'btn-primary',
          true,
          this.windowHash
        ),
        (success) => {
          this.newEvent('new');
        }
      );
    } else {
      this.headerActionsService.clearActions();
      // Se muestra el título solo en el calendario del usuario
      if (this.calMode === 'MU') {
        this.headerActionsService.setTaskDescription(
          this.elem,
          'Calendar.user.events',
          'fa fa-calendar-alt',
          true
        );
      }
      this.subscribe(
        this.headerActionsService.addAction(
          'Calendar.add',
          'fas fa-plus',
          'btn-primary',
          true
        ),
        (success) => {
          this.newEvent('new');
        }
      );

      this.headerActionsService.addDivider();

      this.subscribe(
        this.headerActionsService.addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ),
        (success) => {
          this.uiService.routeBack();
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.isModalWindow) {
      this.headerActionsService.clearWindowActions(this.windowHash);
    } else {
      this.headerActionsService.clearActions();
    }

    super.ngOnDestroy();
  }

  public isProjectLoaded(): boolean {
    return this.loaded;
  }

  loadEvents(info) {
    this.waitService.startWaiting();
    let startDate: Date;
    let endDate: Date;
    let view = info && info.view ? info.view : undefined;
    if (view && view.currentStart && view.currentEnd) {
      startDate = view.currentStart;
      endDate = view.currentEnd;
      endDate.setDate(endDate.getDate() - 1);
    } else {
      let date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth();
      startDate = new Date(year, month, 1);
      endDate = new Date(year, month + 1, 0);
    }

    /*
        let firstDayMonthString =
          this.datePipe.transform(startDate, 'dd/MM/yyyy');
        + ' / 00:00';
        let lastDayMonthString =
          this.datePipe.transform(endDate, 'dd/MM/yyyy');
        + ' / 23:59';
    */
    let dossierid =
      this.project && this.project.identifier
        ? this.project.identifier
        : undefined;
    this.loadMillestonesByUserByDatePattern(dossierid, startDate, endDate);
  }

  functionToCloseDialog() {
    this.dialogVisible = false;
  }

  handleEventClick(e) {
    let myEvent = new MilestoneDTO();
    let calEvent = e.event;
    myEvent.description = calEvent.title;
    myEvent.observations = calEvent.extendedProps.observations;
    myEvent.place = calEvent.extendedProps.place;
    myEvent.identifier = calEvent.id;
    myEvent.typeMilestone = {};
    myEvent.typeMilestone.identifier = calEvent.extendedProps.type;
    myEvent.typeMilestone.mode = calEvent.extendedProps.mode;
    myEvent.typeMilestone.canModify = calEvent.extendedProps.canModify;
    myEvent.typeMilestone.allowDivision = calEvent.extendedProps.allowDivision;

    /*
        let start = calEvent.start;
        let end = calEvent.end;
        if (e.view.name === 'month') {
          start.stripTime();
        }

        if (end) {
          end.stripTime();
          myEvent.end = end;
        }

        myEvent.id = calEvent.id;
        myEvent.start = start;
        myEvent.allDay = calEvent.allDay;
        myEvent.type = calEvent.type;
    */

    myEvent.dateMilestone = calEvent.extendedProps.stamp;

    this.openEvent(myEvent);
    this.dialogVisible = true;
  }

  openEvent(calendarEvent: MilestoneDTO) {
    /*

       //un hito sera modificable, si se define como tal en el modo en el que se esta abriendo el calendario
        private boolean isModificableHITO(TipoHITOS tipoHITO) {
        boolean modificable = false;
        if (infoCalendario.isModoExpediente() && tipoHITO.isModoExpediente()) {
          modificable = tipoHITO.isModificable();
        } else if (infoCalendario.isModoUsuario() && tipoHITO.isModoUsuario()) {
          modificable = tipoHITO.isModificable();
        }
        return modificable;
        }


    */
    //    let readonly = calendarEvent != undefined && calendarEvent.typeMilestone != undefined
    //    && calendarEvent.typeMilestone.identifier != undefined && calendarEvent.typeMilestone.identifier != 'OTRU';
    let update =
      calendarEvent !== undefined &&
      calendarEvent.typeMilestone !== undefined &&
      calendarEvent.typeMilestone.identifier !== undefined &&
      this.calMode === calendarEvent.typeMilestone.mode &&
      calendarEvent.typeMilestone.canModify;
    let readonly = !update;

    let context = calendarEvent;

    let config: DynamicDialogConfig = {
      header: this.translationService.instant('Calendar.milestone.title'),
      width: '60%',

      styleClass: readonly ? 'viewStyle' : 'formEdition',
    };
    config['readonly'] = readonly;
    config['calMode'] = this.calMode;
    config['context'] = context;
    config['id'] = calendarEvent.identifier;
    config['types'] = this.types;
    if (this.project && this.project.identifier) {
      config['project'] = this.project;
    }

    let curentHelpTags = [];
    this.subscribe(
      this.helpService
        .getStoreTagsObservable()
        .pipe(switchMap((helpTags) => (curentHelpTags = helpTags)))
    );
    const ref = this.dialogService.open(CalendarEventComponent, config);
    this.subscribe(ref.onClose, (result) => {
      this.subscribe(
        this.helpService.showContextHelpObservable(curentHelpTags)
      );
      this.loadEvents(this.calendarView.calendar.component);
      if (result) {
        console.log(result);
      }
    });
  }

  private loadMillestonesByUserByDatePattern(
    dossier: string,
    iniDate: Date,
    endDate: Date
  ) {
    let eventProcess: Array<any> = [];
    // this.eventsWeek = [];
    // this.waitService.startWaiting();
    this.subscribe(
      this.plycaService
        .getMillestones(
          dossier,
          new Date(iniDate).getTime(),
          new Date(endDate).getTime()
        )
        .pipe(
          tap((param: PaginationDTO<MilestoneDTO>) => {
            if (param) {
              this.millestones = param.content;

              this.millestones.forEach((x: MilestoneDTO) => {
                eventProcess.push({
                  title: x.description,
                  start: this.datePipe.transform(x.dateMilestone, 'yyyy-MM-dd'),
                  observations: x.observations,
                  type: x.typeMilestone.identifier,
                  place: x.place,
                  stamp: x.dateMilestone,
                  id: x.identifier,
                  mode: x.typeMilestone.modo,
                  canModify: x.typeMilestone.modificable,
                  enabledDivision: x.typeMilestone.permiteDivision,
                });
                // console.log('size', eventProcess.length);
              });
            }
          }),
          finalize(() => {
            this.waitService.cancelWaiting();
          })
        ),
      () => (this.events = eventProcess)
    );
  }

  newEvent(id, milestoneType?: any) {
    let config: DynamicDialogConfig = {
      header: this.translationService.instant('Calendar.milestone.new'),
      width: '60%',

      styleClass: 'formEdition',
    };

    config['id'] = id;
    config['calMode'] = this.calMode;

    if (this.project && this.project.identifier) {
      let calendarEvent = new MilestoneDTO();
      if (milestoneType) {
        calendarEvent.typeMilestone = milestoneType;
        let i = calendarEvent.typeMilestone.identifier;
        if (i.indexOf('<>') < 0) {
          i = calendarEvent.typeMilestone.identifier + '<>HITOS_TIPOS';
        }

        calendarEvent.typeMilestone.identifier = i;
        config['typeMilestone'] = milestoneType;
      }

      calendarEvent.project = {} as ProjectEntityDTO;
      calendarEvent.project.identifier = this.project.identifier;
      config['project'] = this.project;
      config['division'] = this.division;
      config['context'] = calendarEvent;
    }

    const a = this.dialogService.open(CalendarEventComponent, config);
    this.subscribe(a.onClose, (newObject) => {
      this.loadEvents(this.calendarView.calendar.component);
    });
  }

  getLabelsByObject(objArray: Array<any>): Array<string> {
    let labels: Array<string> = [];
    objArray.forEach((obj) => {
      try {
        labels.push(
          'D_' + getSimpleIdentifierFromString(obj.documentClass.abbreviation)
        );
      } catch (ex) {}

      try {
        labels.push('P_' + getSimpleIdentifierFromString(obj.type.identifier));
      } catch (ex) {}

      try {
        labels.push(
          'VN_' +
            getSimpleIdentifierFromString(obj.applicableLegislation.identifier)
        );
      } catch (ex) {}
    });

    return labels;
  }
}
